import * as apiGetVenueTasks from "@/api/vp/venueTasks/getVenueTasks";
import * as apiAddVenueTask from "@/api/vp/venueTasks/addVenueTask";
import * as apiUpdateVenueTask from "@/api/vp/venueTasks/updateVenueTask";
import * as apiDeleteVenueTask from "@/api/vp/venueTasks/deleteVenueTask";
import * as apiSetVenueTaskChecked from "@/api/vp/venueTasks/setVenueTaskChecked";
import * as apiSetVenueTaskUnchecked from "@/api/vp/venueTasks/setVenueTaskUnchecked";
import * as apiUpdateVenueTaskDate from "@/api/vp/venueTasks/updateVenueTaskDate";
import * as apiGetActiveUserRoles from "@/api/vp/personalTodos/getActiveUserRoles.js";
import _, { identity } from "lodash";

export default {
  namespaced: true,
  state: {
    loading: false,
    tasks: [],
    roles: [],
  },
  mutations: {
    gotVenueTasks(state, result) {
      state.tasks = result;
    },
    isLoading(state, loading) {
      state.loading = loading;
    },
    gotUserRoles(state, result) {
      state.roles = result;
    },
  },
  actions: {
    async getVenueTasks({ commit }, { venueId, year, week }) {
      commit("isLoading", true);

      const result = await apiGetVenueTasks.get(venueId, year, week);

      if (result) {
        commit("gotVenueTasks", result);
      }

      commit("isLoading", false);
    },

    async addVenueTask({ commit, dispatch }, task) {
      const result = await apiAddVenueTask.post(task);

      return result;
    },

    async deleteVenueTask({ commit, dispatch }, venueTaskId) {
      await apiDeleteVenueTask.del(venueTaskId);

    },

    async updateVenueTaskDate({ commit, dispatch }, dto) {
      const result = await apiUpdateVenueTaskDate.post(dto);

      return result;
    },

    async updateVenueTask({ commit, dispatch }, task) {
      const result = await apiUpdateVenueTask.put(task);

      return result;
    },

    async changeChecked(
      { commit, dispatch },
      { venueTaskId, venueId, date, checked }
    ) {

      return checked
        ? await apiSetVenueTaskChecked.put(venueTaskId, venueId, date)
        : await apiSetVenueTaskUnchecked.put(venueTaskId, venueId, date);
    },

    async getUserRoles({ commit, state }, venueId) {
      commit("isLoading", true);

      const result = await apiGetActiveUserRoles.get(venueId);

      if (result) {
        commit("gotUserRoles", result);
      }

      commit("isLoading", false);
    },


  },
  getters: {
    tasks: state => {
      return state.tasks;
    },
    roles: state => state.roles,
  }
};
